import React from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <section id="contact" className="bg-phoenix-beige py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2
          className="text-3xl font-bold text-phoenix-gold mb-12 text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Contact Us
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-semibold text-phoenix-black mb-4">Clinic Information</h3>
            <p className="text-phoenix-black mb-2">Priyadarshini Colony, Chandrampalem, Srinivasa Nagar, Madhurawada, Visakhapatnam, Andhra Pradesh 530048</p>
            <p className="text-phoenix-black mb-2">Phone:+91-9949042692</p>
            <p className="text-phoenix-black mb-4">Email: info@phoenixdental.com</p>
            <div className="aspect-w-16 aspect-h-9">
              <iframe
                title="Phoenix Dental Location"
                src="https://maps.google.com/maps?q=17.8206044,83.3574274&hl=en&z=15&amp;output=embed"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h3 className="text-xl font-semibold text-phoenix-black mb-4">Appointment Form</h3>
            <form className="space-y-4">
              <div>
                <label htmlFor="name" className="block text-phoenix-black font-medium mb-1">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="w-full border border-gray-300 rounded-md p-2"
                  required
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-phoenix-black font-medium mb-1">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="w-full border border-gray-300 rounded-md p-2"
                  required
                />
              </div>
              <div>
                <label htmlFor="phone" className="block text-phoenix-black font-medium mb-1">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  className="w-full border border-gray-300 rounded-md p-2"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-phoenix-black font-medium mb-1">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  className="w-full border border-gray-300 rounded-md p-2"
                ></textarea>
              </div>
              <motion.button
                type="submit"
                className="bg-phoenix-gold text-phoenix-white px-6 py-3 rounded-lg hover:bg-opacity-80 transition-colors"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Submit
              </motion.button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
